import Icon from '@/componentsDS/Icon/Icon';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const size =Object.freeze({
	SMALL :'small',
	MEDIUM : 'medium',
	LARGE : 'large',
	XLARGE : 'xlarge'
})
const style= Object.freeze(
	{
		OUTLINED :'outlined',
		SOLID : 'solid'
	}
)
const Badge = ({
	dataTestId = 'badge',
	iconImg = (
		<Icon
			name="notificationBell"
			size={size.MEDIUM}
			style={style.OUTLINED}
		/>
	),
	withIcon = true,
	isDotBadge = false,
	notificationArray = [],
	children
}) => {
	const badgeNumericClass = classNames({
		'DS__badge-numerical': true,
		'DS__badge-numerical--with-icon': withIcon
	});

	const badgeDotClass = classNames({
		'DS__badge-dot': true,
		'DS__badge-dot--with-icon': withIcon && !children,
		'DS__badge-dot--with-child': children
	});

	const badgeValue =
		notificationArray?.length >= 100 ? '99+' : notificationArray?.length;

	return (
		<div className="DS__badge" data-testid={dataTestId}>
			{withIcon && (
				<div className="DS__badge__icon" data-testid="badge-icon">
					{children || iconImg}
				</div>
			)}
			{isDotBadge ? (
				<div className={badgeDotClass} data-testid="badge-dot"></div>
			) : (
				notificationArray?.length > 0 && (
					<div
						className={badgeNumericClass}
						data-testid="badge-numeric"
					>
						{badgeValue}
					</div>
				)
			)}
		</div>
	);
};

export default Badge;

Badge.propTypes = {
	dataTestId: PropTypes.string,
	iconImg: PropTypes.element,
	withIcon: PropTypes.bool,
	isDotBadge: PropTypes.bool,
	notificationArray: PropTypes.arrayOf(PropTypes.object),
	children: PropTypes.node,
  };
